import { FadMediaList } from './profile.types';

export const changeVideoUrl = (media: FadMediaList): string => {
  if (!media) return '';

  const { url, type } = media;
  if (!url) return '';

  const retUrl = type && type.toLowerCase() === 'video' ? url.replace('watch?v=', 'embed/') : url;

  return `${retUrl}?enablejsapi=1`;
};

export const createWebsiteUrl = (website: string): string =>
  website?.toLowerCase()?.indexOf('http') === -1 ? `https://${website.trim()}` : website;
